import { AxiosResponse } from 'axios'
import { request } from './http-client'
import { IShipper } from '../_types'

const getShipperById = (id: string): Promise<AxiosResponse<IShipper>> =>
  request.get(`/v1/shippers/${id}`)

export default getShipperById
